import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import Image from '../Image/Image';
import Heading, { HeadingTypes } from '../Heading/Heading';
import SbImage from '../SbImage/SbImage';

export interface CTABarSmallBlokProps extends Blok {
  background_image: StoryblokAsset;
  heading: string;
  body?: string;
  cta: Blok[];
}

export interface CTABarSmallProps {
  blok: CTABarSmallBlokProps;
}

const CTABarSmall: React.FC<CTABarSmallProps> = ({ blok }) => {
  const { background_image, heading, body, cta } = blok;

  return (
    <div {...storyblokEditable(blok)} className="w-full relative">
      {background_image?.filename && (
        <div className="absolute top-0 right-0 bottom-0 left-0 overflow-hidden">
          <SbImage asset={background_image} options={{ objectFit: 'cover', sizes: { base: 600, md: 768, lg: 1024, xl: 1280, xxl: 1440 } }} />
        </div>
      )}
      <div className="relative w-full flex items-center justify-center bg-[#0B212E]/80 px-3.5 py-14 lg:px-20">
        <div className="w-full flex flex-col items-center justify-center gap-y-8 lg:w-full lg:flex-row lg:justify-between lg:gap-x-6">
          <div className="space-y-5 text-center lg:text-left">
            {heading && (
              <Heading text={heading} headingType={HeadingTypes.h2} />
            )}
            {body && <p className="text-text/body text-xl">{body}</p>}
          </div>
          {cta.map((cta_item: Blok) => (
            <div className="w-full sm:w-fit sm:max-w-fit" key={cta_item._uid}>
              <StoryblokComponent blok={cta_item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(withBlokWrapper(CTABarSmall, Theme.DARK));
